import { render, staticRenderFns } from "./tousuBack.vue?vue&type=template&id=4cdc7f56&scoped=true&"
import script from "./tousuBack.vue?vue&type=script&lang=js&"
export * from "./tousuBack.vue?vue&type=script&lang=js&"
import style0 from "./tousuBack.vue?vue&type=style&index=0&id=4cdc7f56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdc7f56",
  null
  
)

export default component.exports